/*
 * @Author: shen
 * @Date: 2021-07-18 12:25:41
 * @LastEditors: shen
 * @LastEditTime: 2021-07-18 12:39:03
 * @Description:
 */
import Store from './core/store'
import defaultOptions from './default'

let instance

function createStore(options) {
  const opts = Object.assign({}, defaultOptions, options)
  if (!instance) {
    instance = new Store(opts)
  }

  return instance
}

export default createStore
